import React from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextField } from '../shared/form/formik/FormikTextField'
import { FormikRadioGroup } from '../shared/form/formik/FormikRadioGroup'
import { BankPaymentAccountType } from './BankPaymentForm.constants'
import { useFormikContext } from 'formik'

interface BankInformationContentProps {
  hasBusinessEntity?: boolean
  handleChange: (e: React.ChangeEvent<any>) => void
}

const ACCOUNT_NUMBER_MASK = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

const paymentAccountOptions = [
  { label: 'Checking', value: BankPaymentAccountType.CHECKING },
  { label: 'Savings', value: BankPaymentAccountType.SAVINGS },
]

export const BankInformationContent = ({
  handleChange,
  hasBusinessEntity = false,
}: BankInformationContentProps) => {
  const { values } = useFormikContext<any>()

  const hasPrefilledName = !!values.nameOnCard

  return (
    <>
      {!hasBusinessEntity && (
        <div css={tw`mb-4 p-3 flex flex-row items-center rounded-2xl bg-primary-100`}>
          <div
            css={tw`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mr-3 bg-primary-500`}
          >
            <Typography css={tw`text-white text-xs font-bold`}>i</Typography>
          </div>
          <div css={tw`flex flex-col`}>
            <Typography css={tw`text-sm text-primary-500`} style={{ fontSize: '16px' }}>
              Please provide an Individual Bank Account. To use a Business Account, add your
              business entity details.
            </Typography>
            <Typography css={tw`text-sm text-primary-500`} style={{ fontSize: '16px' }}>
              Contact support if you need help.
            </Typography>
          </div>
        </div>
      )}
      <div css={tw`mb-4`}>
        <FormikTextField
          name="nameOnCard"
          placeholder="Enter name on account"
          label={hasBusinessEntity ? 'Business name' : 'Full name'}
          onChange={handleChange}
          disabled={hasPrefilledName}
          css={tw`w-full`}
        />
        {hasPrefilledName && (
          <div
            css={tw`mt-2 p-3 flex flex-row items-center rounded-2xl`}
            style={{ backgroundColor: 'var(--mui-shades-100)' }}
          >
            <div
              css={tw`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mr-3`}
              style={{ backgroundColor: '#4A3F57' }}
            >
              <Typography css={tw`text-white text-xs font-bold`}>i</Typography>
            </div>
            <div css={tw`flex flex-col`}>
              <Typography css={tw`text-sm`} style={{ color: '#4A3F57', fontSize: '16px' }}>
                {hasBusinessEntity ? 'Business name' : 'Full name'} is prefilled with your verified
                legal name and can't be edited. Contact support if you need help.
              </Typography>
            </div>
          </div>
        )}
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="routingNumber"
          placeholder="Enter routing number"
          label="Routing number"
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="accountNumber"
          placeholder="Enter account number"
          label="Account number"
          mask={ACCOUNT_NUMBER_MASK}
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikRadioGroup
          label="Select preferable option"
          name="accountType"
          options={paymentAccountOptions}
          onChange={handleChange}
        />
      </div>
    </>
  )
}
